import React from "react";

interface InsuranceIconProps {
  isActive?: boolean;
}

export const InsuranceIcon: React.FC<InsuranceIconProps> = ({ isActive }) => {
  const color = isActive ? "var(--active-color)" : "#83829D";
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3L5 6V11C5 15.55 8.11 19.74 12 21C15.89 19.74 19 15.55 19 11V6L12 3Z"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.5L11 14.5L15 10.5"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

